module.exports = __webpack_public_path__ + "static/media/ImgClose.070c7943.svg";